function transformDate (dateReceived) {
    const date = new Date(dateReceived._seconds * 1000 + dateReceived._nanoseconds / 1000, );
    const stringDate = date.toLocaleDateString("es-ES", {day: "2-digit", month: "2-digit", year: "numeric"});
    return stringDate;
}

module.exports = {transformDate}